"use client"

import { useState } from "react"
import { ShoppingCart } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"
import { CartDrawer } from "@/components/cart-drawer"
import { useCart } from "@/contexts/cart-context"
import { formatCurrency } from "@/lib/utils"
import { ShoppingBag } from "lucide-react"

export function MobileCartCTA() {
  const [isCartOpen, setIsCartOpen] = useState(false)
  const { cart } = useCart()
  
  
  if (!cart || cart.items.length === 0) return null

  const cartItemsCount = cart.items.reduce((sum, item) => sum + item.quantity, 0)
  const cartTotal = cart.items.reduce((sum, item) => sum + (item.price * item.quantity), 0)

  return (
    <>
      {/* Mobile Cart CTA - Fixed Bottom */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t p-4 md:hidden">
        <Button className="w-full" size="lg" onClick={() => setIsCartOpen(true)}>
          <ShoppingBag className="mr-2 h-4 w-4" />
          View Cart ({cartItemsCount}) - {formatCurrency(cartTotal)}
        </Button>
      </div>

      {/* Add padding to prevent content from being hidden behind the fixed CTA */}
      <div className="h-20 md:hidden" />

      <CartDrawer open={isCartOpen} onOpenChange={setIsCartOpen} />
    </>
  )
}
